import { LoadingOutlined, SyncOutlined } from '@ant-design/icons';
import { Button, Spin } from 'antd';
import qrLogo from 'assets/images/onboarding/qr-logo.svg';
import QRCode from 'qrcode.react';
import React from 'react';
import { FormattedMessage } from 'react-intl';

export default function QrCodeScreen({
	qrcode,
	numberDisconnected,
	showContainerMsg,
	isRegeneratingQr,
	qrError,
	onReloadQr,
}) {
	const isLoading = isRegeneratingQr || (showContainerMsg && !numberDisconnected);

	return (
		<div className="qr-screen">
			<div className="qr-screen-instructions">
				<h1 className="qr-screen-title">
					<FormattedMessage id="qr_title" />
				</h1>
				<p className="qr-screen-subtitle">
					<FormattedMessage id="qr_subtitle" />
				</p>
				<p className="qr-screen-before">
					<FormattedMessage id="qr_before" />
				</p>
				<ol>
					<li>
						<FormattedMessage id="qr_step_1" />
					</li>
					<li>
						<FormattedMessage id="qr_step_2" />
					</li>
					<li>
						<FormattedMessage id="qr_step_3" />
					</li>
				</ol>
				<p>
					<FormattedMessage id="qr_after" values={{ b: (chunks) => <strong>{chunks}</strong> }} />
				</p>
			</div>
			<div className="qr-screen-code">
				<div className="qr-code-box" role={isLoading ? 'status' : undefined} aria-live="polite">
					{isLoading ? (
						<>
							<Spin indicator={<LoadingOutlined style={{ fontSize: 32 }} spin />} />
							<span className="qr-loading-title">
								<FormattedMessage id="qr_loading" />
							</span>
							<span className="qr-loading-description">
								<FormattedMessage id="qr_loading_hint" />
							</span>
						</>
					) : qrcode && !numberDisconnected ? (
						// Logo cobre ~4% da area; nivel M corrige ate 15%. Medido com jsQR em 1x/1.25x/1.5x:
						// o nivel H deixa o QR do WhatsApp com 81 modulos e em 170px ele nao le em 1x.
						<QRCode
							value={qrcode}
							size={170}
							level="M"
							bgColor="#ffffff"
							fgColor="#000000"
							imageSettings={{ src: qrLogo, height: 34, width: 34, excavate: true }}
						/>
					) : null}
				</div>
				{numberDisconnected ? (
					<p className="qr-code-error">
						<FormattedMessage id="qr_expired" />
					</p>
				) : null}
				{qrError ? <p className="qr-code-error">{qrError}</p> : null}
				{!showContainerMsg || isRegeneratingQr ? (
					// Sem `loading`: o antd poe icone e recuo de 29px, o botao passava dos 194px da coluna
					// e empurrava o QR. O progresso ja aparece no quadrado ("Preparando seu QR Code").
					<Button
						type="link"
						onClick={onReloadQr}
						disabled={isRegeneratingQr}
						className="qr-regenerate-button"
					>
						<SyncOutlined spin={isRegeneratingQr} />
						<FormattedMessage id="qr_regenerate" />
					</Button>
				) : null}
			</div>
		</div>
	);
}
